import { Box, Stack, Zoom } from "@mui/material";
import { Answer, Question } from "../../../../domain/model/Question";
import { CustomTextView } from "../../../component/CustomTextView";
import { CustomImageView } from "../../../component/CustomImageView";
import { COLOR_WHITE } from "../../../../data/colors/Colors";
import { AudioFileRounded } from "@mui/icons-material";
import {
  Attachment,
  AttachmentType,
} from "../../../../domain/model/Attachment";
import ReactPlayer from "react-player";
import ReactAudioPlayer from "react-audio-player";
import { useEffect, useState } from "react";
import ZoomView from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";

export function QuestionAnswerDetailsView({
  question,
  answer,
  showAnswer,
  showAttachment,
  isMobile,
}: {
  question: Question;
  answer: Answer;
  showAnswer: boolean;
  showAttachment: boolean;
  isMobile: boolean;
}) {
  const [checked, setChecked] = useState(false);
  useEffect(() => {
    setChecked(false);
    setTimeout(() => {
      setChecked(true);
    }, 100);
  }, [showAnswer]);
  return (
    <Zoom in={checked}>
      <Stack
        width={"100%"}
        height={"100%"}
        alignItems={"center"}
        justifyContent={
          (showAnswer && !answer.attachment) || !question.attachment
            ? "center"
            : "space-between"
        }
        gap={2}
      >
        <Box />
        {checked && (
          <CustomTextView
            text={
              showAnswer
                ? `${answer.title}`
                : `${question.title?.replaceAll("؟", "").replaceAll("?", "")}${"؟"}`
            }
            fontWeight="bold"
            variant={isMobile ? "h6" : "h4"}
            textAlign="center"
            textColor={COLOR_WHITE}
            props={{ direction: "rtl" }}
          />
        )}

        {checked &&
          (showAnswer
            ? answer.attachment && (
                <AttachmentView
                  attachment={answer.attachment}
                  isMobile={isMobile}
                />
              )
            : showAttachment &&
              question.attachment && (
                <AttachmentView
                  attachment={question.attachment}
                  isMobile={isMobile}
                />
              ))}

        {!showAttachment && !showAnswer && <Box />}
      </Stack>
    </Zoom>
  );
}

export function AttachmentView({
  attachment,
  isMobile,
  heightInput,
  imageWidth = "80%",
  scale = "contain",
}: {
  attachment: Attachment;
  isMobile?: boolean;
  heightInput?: string;
  imageWidth?: string;
  scale?: "cover" | "contain";
}) {
  const height = (heightInput ?? isMobile) ? "35vh" : "32vh";

  switch (attachment.type) {
    case AttachmentType.IMAGE:
      return (
        <Stack width={imageWidth}>
          <ZoomView>
            <CustomImageView
              src={attachment.downloadUrl}
              width={"100%"}
              height={height}
              scale={scale}
              props={{
                borderRadius: 6,
                background: COLOR_WHITE,
              }}
            />
          </ZoomView>
        </Stack>
      );

    case AttachmentType.VIDEO:
      return (
        <Stack height={height} width={"100%"}>
          <ReactPlayer
            width={"100%"}
            height={"100%"}
            style={{ background: COLOR_WHITE, borderRadius: 22 }}
            controls={true}
            src={attachment.downloadUrl}
          />
        </Stack>
      );
    case AttachmentType.AUDIO:
      return (
        <Stack height={height} width={"100%"}>
          <Box
            sx={{
              width: "100%",
              height: "100%",
              alignItems: "center",
              justifyContent: "center",
              display: "flex",
            }}
          >
            <AudioFileRounded
              sx={{
                color: COLOR_WHITE,
                width: "8vw",
                height: "8vw",
              }}
            />
          </Box>
          <ReactAudioPlayer
            style={{ width: "100%", height: "20%" }}
            src={attachment.downloadUrl}
            controls
          />
        </Stack>
      );
  }
}
